export enum PendingAction {
    SAVE = 'SAVE',
    SAVE_WITH_TASK = 'SAVE_WITH_TASK',
}
